var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useEffect, useRef } from "react";
import Portal from "../portal/Portal";
import { Container } from "./styled/drawer";
export var DrawerContext = createContext({
    onClose: function () {
        console.warn("Please implement an onClose method for drawer.");
    }
});
function Drawer(_a) {
    var _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.direction, direction = _d === void 0 ? "left" : _d, _e = _a.semiTransparentBackground, semiTransparentBackground = _e === void 0 ? true : _e, children = _a.children, props = __rest(_a, ["onClose", "onClick", "direction", "semiTransparentBackground", "children"]);
    var containerRef = useRef(null);
    var handleClick = function (e) {
        onClick(e);
        if (containerRef.current === e.target)
            onClose();
    };
    useEffect(function () {
        var el = document.querySelector(".drawer-content");
        el === null || el === void 0 ? void 0 : el.classList.add("drawer-open");
        return function () {
            el === null || el === void 0 ? void 0 : el.classList.remove("drawer-open");
        };
    }, []);
    return (React.createElement(Portal, null,
        React.createElement(DrawerContext.Provider, { value: { onClose: onClose } },
            React.createElement(Container, __assign({ className: "drawer-component", direction: direction, semiTransparentBackground: semiTransparentBackground }, props, { ref: containerRef, onClick: handleClick }),
                React.createElement("div", { className: "drawer-content", role: "dialog" }, children)))));
}
export default Drawer;
